<div class="jk-rich-editor">
  @if(label) {
  <div style="margin-bottom:4px;">
    <label style="font-size:12px; color:#555;">{{ label }}
      @if(required()) {
      <span style="color:red;">*</span>
      }
    </label>
  </div>
  }
  @if(readonly()) {
  <quill-editor [ngModel]="editorValue" [readOnly]="true"
    [modules]="{toolbar: false}" theme="bubble"
    style="display:block; min-height:150px; border:1px solid #ccc; border-radius:4px;">
  </quill-editor>
  } @else {
  <input #imageInput type="file" accept="image/*" style="display:none"
    (change)="onImageFileSelected($event)">
  <quill-editor theme="snow" [ngModel]="editorValue" (ngModelChange)="onModelChange($event)"
    [modules]="quillModules"
    [style.min-height]="minHeight()"
    style="display:block; width:100%;"
    (onEditorCreated)="onQuillEditorCreated($event)">
  </quill-editor>
  <div style="margin-top:4px;">
    <button type="button" mat-stroked-button color="primary"
      style="font-size:12px; height:28px; line-height:28px;"
      (click)="toggleMinioImages()">
      {{ showMinioImages ? '收起已上傳圖片' : '選擇已上傳圖片' }}
    </button>
  </div>
  @if(showMinioImages) {
  <div style="border:1px solid #ddd; border-radius:4px; padding:8px; margin-top:4px; min-height:60px;">
    @if(minioImagesLoading) {
    <span style="color:#888; font-size:13px;">載入中...</span>
    } @else if(minioImages.length === 0) {
    <span style="color:#aaa; font-size:13px;">此單號尚無已上傳圖片</span>
    } @else {
    @for(img of minioImages; track img.url) {
    <img [src]="img.url" [title]="img.name"
      (click)="insertMinioImage(img.url)"
      style="width:100px; height:80px; object-fit:cover; cursor:pointer; margin:4px; border:1px solid #ccc; border-radius:4px;">
    }
    }
  </div>
  }
  }
</div>
